import { keyframes } from '@emotion/react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import dataManagement from '../assets/data-management.png';
import rocket from '../assets/rocket.png';
import secureShield from '../assets/secure-shield.png';
import support from '../assets/support.png';

import { Box, Button, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const featureItems = [
  {
    title: 'Performance',
    icon: rocket,
    subtitle: 'We build high-performance solutions that ensure fast loading times, smooth user experiences, and minimal resource consumption',
  },
  {
    title: 'Security',
    icon: support,
    subtitle: 'Security is our top priority. We implement industry-leading practices to protect your data, prevent breaches, and ensure safe transactions.',
  },
  {
    title: 'Support',
    icon: secureShield,
    subtitle: 'Our dedicated support team is here to help you every step of the way. Whether it’s troubleshooting, updates, or guidance.',
  },
  {
    title: 'Scalability',
    icon: dataManagement,
    subtitle: 'We design solutions that grow with your business. Whether you are handling 100 users or 1 million.',
  },
];

const springBounceY = keyframes`
  0%   { transform: translateY(0); }
  30%  { transform: translateY(-12px); }
  50%  { transform: translateY(4px); }
  70%  { transform: translateY(-6px); }
  100% { transform: translateY(0); }
`;

const FeatureSection = () => {
  return (
    <Box sx= {{ width: '100%', backgroundColor:'white' }}>
    <Box
      sx={{
        width: {
          xs: '95%',
          sm: '100%',
          md: '85%',
          lg: '85%',
          xl: '85%',
        },
        px: { xs: '16px', sm: '24px' },
        mx: 'auto',
        py: '70px',

      }} maxWidth="lg"
    >
      {/* Header and Button Row */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between',
          mb: 6,
        }}
      >
        {/* Left Text Block */}
        <Box sx={{ textAlign: 'left' }}>
          <Typography
            variant="h5"
            sx={{
              fontFamily: 'Rajdhani',
              fontWeight: 600,
              fontSize: '19px',
              color: '#0c5adb',
            }}
          >
            SERVICE WE PROVIDE
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontFamily: 'Rajdhani',
              color: '#232323',
              fontWeight: 'bold',
              lineHeight: 1.2,
            }}
          >
            All Professional We’re Offering Best <br />
            IT Solutions & <span style={{ color: '#075AD6' }}>Services</span>
          </Typography>
        </Box>

        <Box>
          <Button
            sx={{

              position: 'relative',
              overflow: 'hidden',
              borderRadius: '3px',
              mr:"5px",
              px: '15px',
              py: '5px',
              textTransform: 'uppercase',
              fontWeight: 600,
              fontFamily: 'Rajdhani',
              fontSize: '17px',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              backgroundColor: '#0c5ADB',
              color: '#fff',
              border: '2px solid #0c5ADB',
              transition:
                'color 0.4s ease-in-out, background-color 0.4s ease-in-out',

              '& span, & .arrow-circle': {
                position: 'relative',
                zIndex: 1,
              },

              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '102%',
                backgroundColor: '#fff',
                zIndex: 0,
                transform: 'translateX(101%)',
                transition: 'transform 0.4s ease-in-out',
              },

              '&:hover::before': {
                transform: 'translateX(0%)',
              },

              '&:not(:hover)::before': {
                transform: 'translateX(-100%)',
              },

              '& .arrow-circle': {
                backgroundColor: '#fff',
                color: '#075AD6',
                borderRadius: '50%',
                padding: '3px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.4s ease-in-out',
              },

              '&:hover': {
                color: '#075AD6',
                '& .arrow-circle': {
                  backgroundColor: '#0c5ADB',
                  color: '#fff',
                },
              },
            }}
            component={Link} to="/services"
          >
            <span>SERVICES</span>
            <span className="arrow-circle">
              <ArrowForwardIcon fontSize="small" />
            </span>
          </Button>
        </Box>
      </Box>

      <Box sx={{ width: '100%' }}>
        <Grid container spacing={2} justifyContent={{ xs: 'center', md: 'space-between' }}>
          {featureItems.map((item, index) => (
            <Grid item key={index} xs={12} sm={6} md={3}>
              <Box
                sx={{

                  width: '240px',
                  height: '300px',
                  position: 'relative',
                  textAlign: 'center',
                  borderRadius: 0.5,
                  border: '1px solid rgb(214, 211, 211)',
                  padding: 3,
                  overflow: 'hidden',
                  transition: 'transform 0.3s ease',
                  cursor: 'pointer',
                  margin: '0 auto',
                  '&:hover .overlay': {
                    transform: 'translateY(0)',
                  },
                  '&:hover .star-icon': {
                    animation: `${springBounceY} 1s ease`,
                  },
                  '&:hover .feature-text': {
                    color: 'white',
                  },
                  '&:hover .hover-line': {
                    backgroundColor: 'white',
                  },
                }}
              >
                <Box
                  className="overlay"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#075AD6',
                    borderRadius: 0.5,
                    zIndex: 1,
                    transform: 'translateY(100%)',
                    transition: 'transform 0.5s ease-in-out',
                  }}
                >
                  {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                    <Box
                      key={i}
                      sx={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        transform: 'translate(-50%, -50%)',
                        width: `${i * 40}px`,
                        height: `${i * 40}px`,
                        borderRadius: '50%',
                        border: '2px solid white',
                        opacity: 0.5,
                        zIndex: 2,
                        transition: 'opacity 0.3s ease, transform 0.3s ease',
                      }}
                    />
                  ))}
                </Box>


                <Box
                  sx={{
                    position: 'relative',
                    zIndex: 2,
                    color: 'black',
                    transition: 'color 1s ease',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#d3deec',
                      padding: 2,
                      mb: 2,
                      margin: '0 auto',
                      width: 80,
                      height: 80,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      clipPath:
                        'path("M40 0 C60 0, 80 20, 80 40 C110 60, 60 80, 40 80 C20 80, 0 60, 0 40 C0 20, 20 0, 40 0 Z")',
                      transition: 'all 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'scale(1.05)',
                      },
                    }}
                  >
                    {typeof item.icon === 'string' ? (
                      <img
                        src={item.icon}
                        className="star-icon"
                        alt={item.title}
                        style={{ width: 30, height: 30 }}
                      />
                    ) : (
                      <item.icon
                        className="star-icon"
                        sx={{ fontSize: 40, color: '#075AD6' }}
                      />
                    )}
                  </Box>

                  <Typography
                    variant="h6"
                    mt="10px"
                    className="feature-text"
                    sx={{
                      fontWeight: 700,
                      transition: 'color 1s ease',
                    }}
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    className="feature-text"
                    sx={{
                      mt: 1,
                      whiteSpace: 'pre-line',
                      lineHeight: 1.5,
                      fontWeight: 300,
                      fontFamily: 'Nunito, sans-serif',
                      transition: 'color 1s ease',
                    }}
                  >
                    {item.subtitle}
                  </Typography>
                </Box>

                <Box
                  className="hover-line"
                  sx={{
                    position: 'absolute',
                    bottom: '15px',
                    left: '50%',
                    transform: 'translateX(-50%) scaleX(1)',
                    height: '2px',
                    width: '20%',
                    backgroundColor: '#075AD6',
                    opacity: 1,
                    transition: 'background-color 0.4s ease',
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
    </Box>
  );

};

export default FeatureSection;
